import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import {
  ModalCard,
  ModalFooter,
  useCreateModal,
} from 'partial/components/Modal';
import Button from 'partial/components/Button';
import FormTextArea from 'partial/components/form/FormTextArea';
import { useSendMessage } from '../hooks';

export const useOpenSendMessage = () => {
  const createModal = useCreateModal();

  const openSendMessageModal = useCallback(
    (data) => {
      createModal({
        content: (close) => <SendMessage data={data} onClose={close} />,
      });
    },
    [createModal],
  );

  return openSendMessageModal;
};

function SendMessage({ onClose, data }) {
  const [state, setState] = useState({ content: '' });
  const [isLoading, send] = useSendMessage(onClose);

  const submit = () => {
    send({ uuid: data?.uuid, content: state.content });
  };

  return (
    <ModalCard size="sm" title="Send message" onClose={onClose}>
      <div className="px-5 py-4 w-full">
        <FormTextArea
          name="content"
          onChange={setState}
          value={state.content}
          label="Message"
          placeholder="Type your text here"
          required
        />
      </div>
      <ModalFooter>
        <Button secondary onClick={onClose}>
          Cancel
        </Button>
        <Button
          primary
          isLoading={isLoading}
          loadingLabel="Sending…"
          onClick={submit}
          disabled={state.content.length === 0}
        >
          Send message
        </Button>
      </ModalFooter>
    </ModalCard>
  );
}

SendMessage.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SendMessage;
